import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-management-index',
  templateUrl: './management-index.component.html',
  styleUrls: ['./management-index.component.css']
})
export class ManagementIndexComponent {

  TipoUsuario = TipoUsuario;

  constructor(private authService : AuthService) { }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }


}
